import { useEffect, useState } from 'react'
import './UpcomingEvents.css'
import BidCard from './BidCard'
import { Link } from 'react-router-dom'
import { CiSearch } from "react-icons/ci";
import UpcomingEventsCarousel from './UpcomingEventsCarousel';
import axios from 'axios';
import BidCardSkeleton from './BidCardSkeleton';
import { API_BASE_URL } from '../../utils';
import UpcomingPlanModal from './UpcomingPlanModal';
import noUpcomingEvent from '../image/no-upcoming-events.svg'

export default function UpcomingEvents({ setModalOpen, setSelecteLead }) {

  const userdata = JSON.parse(localStorage.getItem("userData"));


  const [data, setData] = useState([]);
  const [leads, setLeads] = useState([]);

  const [bids, setBids] = useState([]);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);


  const [activeIndex, setActiveIndex] = useState(0);


  useEffect(() => {
    if (activeIndex) {
      const lead = leads.find((lead, index) => lead.id === activeIndex);
      setSelecteLead(lead);
    }
  }, [activeIndex]);




  const fetchUpcomingEvents = async (lat, lng, userId) => {
    try {
      const formData = new FormData();
      formData.append('latitude', lat); //28.6294016 
      formData.append('longitude', lng);//77.0801664 
      formData.append('user_id', userId);//14360

      const response = await axios.post(
        `${API_BASE_URL}/master/APIs/ClubPackage/getGroupBookingUserBids`,
        formData
      );


      if (response.data.status === true) {
        setData(response.data.data);
      } else {
        console.warn('No events found:', response.data.msg);
        setData([]);
      }
    } catch (error) {
      console.error('Error fetching upcoming events:', error);
      setData([]);
    }
  };


  useEffect(() => {
    if (data) {
      const cleaned = Object.values(data).map(({ bids, ...rest }) => rest);
      const allBids = Object.values(data).flatMap(item => item.bids || []);

      setLeads(cleaned);
      setBids(allBids);
    }
  }, [data]);

  useEffect(() => {
    const matched = data.find(item => item.id === activeIndex);
    if (matched) {
      setBids(matched.bids);
    }
  }, [data, activeIndex]);



  useEffect(() => {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          const latStr = latitude.toString();
          const lngStr = longitude.toString();

          setLatitude(latStr);
          setLongitude(lngStr);

          fetchUpcomingEvents(latStr, lngStr, userdata.id);
        },
        (error) => {
          alert('Please enable Geo Location Service to find events in your locality.');
          console.error('Error in finding location:', error);
        }
      );
    } else {
      console.error('Geolocation is not available in this browser.');
    }
  }, []);

  return (
    <>
      <div className='upcoming-events-container'>

        {data.length === 0 ? (
          <>
          <Link to='/package-lead-form'>
            <div className='upcoming-events-empty'>
              <img src={noUpcomingEvent} alt="" />
            </div>
            </Link>
          </>
        ) : (
          <>
            {/* <div>
              <div className='upcoming-events-search'>
                <CiSearch size={24} />
                <input type="search" placeholder='Search' />
              </div>
            </div> */}
            <div className='upcoming-events'>
              <div className='upcoming-events-header'>
                <h3>Upcoming Plan</h3>
              </div>

              <div >
                <UpcomingEventsCarousel leads={leads} setActiveIndex={setActiveIndex} setModalOpen={setModalOpen} />
              </div>

              <div className='upcoming-events-header-bids'>
                <h3>My bids &#40;{bids.length}&#41;</h3>
              </div>

              {bids.length === 0 ? (
                Array.from({ length: 3 }).map((_, index) => <BidCardSkeleton key={index} />)
              ) : (
                bids.slice(0, 3).map((bid, index) => (
                  <BidCard key={index} data={bid} />
                ))
              )}

              <div className='upcoming-events-view-all'>
                <Link to={`/bid-list/${activeIndex}`} className="upcoming-events-view-all-link">
                  <p>View all</p>
                </Link>

              </div>
            </div>
          </>
        )}
      </div >

    </>
  )
}
